@if (isLoading) {
  <div class="gallery-loader">
    <i class="fa-solid fa-spinner fa-spin-pulse custom-spinner"></i>
  </div>
}
